<template>
  <v-sheet
    outlined
    :class="[
      'payment-monitoring-metric',
      `payment-monitoring-metric--${color}`,
    ]"
  >
    <div class="payment-monitoring-metric-topline">
      <div class="payment-monitoring-metric-label">
        {{ label }}
      </div>
      <span class="payment-monitoring-metric-icon">
        <v-icon :color="color">{{ icon }}</v-icon>
      </span>
    </div>
    <div class="payment-monitoring-metric-value">
      <rs-table-cell-number v-if="money" price :value="value || 0" />
      <span v-else>{{
        value === null || value === undefined ? 0 : value
      }}</span>
    </div>
    <div class="payment-monitoring-metric-caption">{{ caption }}</div>
    <div v-if="footLabel" class="payment-monitoring-metric-foot">
      <span>{{ footLabel }}</span>
      <strong>{{ footValue }}</strong>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: "PaymentMonitoringMetric",
  props: {
    label: { type: String, required: true },
    value: { required: false, default: 0 },
    caption: { type: String, default: "" },
    icon: { type: String, default: "mdi-chart-box-outline" },
    color: { type: String, default: "primary" },
    money: { type: Boolean, default: false },
    footLabel: { type: String, default: null },
    footValue: { required: false, default: null },
  },
};
</script>

<style scoped>
.payment-monitoring-metric {
  position: relative;
  min-height: 158px;
  overflow: hidden;
  padding: 16px 16px 42px;
  border-color: #e4e6ef !important;
  border-radius: 6px !important;
  background: #ffffff;
}

.payment-monitoring-metric--primary {
  border-color: rgba(88, 103, 221, 0.28) !important;
  background: linear-gradient(135deg, rgba(88, 103, 221, 0.12), transparent 62%),
    #ffffff;
}

.payment-monitoring-metric--success {
  border-color: rgba(27, 197, 189, 0.28) !important;
  background: linear-gradient(135deg, rgba(27, 197, 189, 0.11), transparent 62%),
    #ffffff;
}

.payment-monitoring-metric--info {
  border-color: rgba(54, 153, 255, 0.26) !important;
  background: linear-gradient(135deg, rgba(54, 153, 255, 0.1), transparent 62%),
    #ffffff;
}

.payment-monitoring-metric--warning {
  border-color: rgba(255, 168, 0, 0.28) !important;
  background: linear-gradient(135deg, rgba(255, 168, 0, 0.1), transparent 62%),
    #ffffff;
}

.payment-monitoring-metric-topline,
.payment-monitoring-metric-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.payment-monitoring-metric-label {
  color: #7e8299;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.payment-monitoring-metric-icon {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(88, 103, 221, 0.09);
}

.payment-monitoring-metric-icon .v-icon {
  font-size: 20px !important;
}

.payment-monitoring-metric-value {
  margin-top: 12px;
  color: #181c32;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
  white-space: nowrap;
}

.payment-monitoring-metric-caption {
  margin-top: 7px;
  color: #7e8299;
  font-size: 12px;
  font-weight: 500;
}

.payment-monitoring-metric-foot {
  position: absolute;
  right: 16px;
  bottom: 12px;
  left: 16px;
  color: #7e8299;
  font-size: 11px;
  font-weight: 600;
}

.payment-monitoring-metric-foot strong {
  color: #3f4254;
  font-weight: 700;
}
</style>
